import {
    BaseQueryFn,
    FetchArgs,
    createApi,
    fetchBaseQuery,
    FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";
import { logout } from "../slices/auth";

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers, { getState }) => {
        headers.set("Accept", "application/json");
        const token = (getState() as RootState).auth?.token;
        if (token) {
            headers.set("Authorization", `Bearer ${token}`);
        }

        return headers;
    },
});

const baseQueryWithInterceptor: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error && result.error.status === 401) {
        api.dispatch(logout({ unauthorized: true }));
    }
    return result;
};

export const api = createApi({
    baseQuery: baseQueryWithInterceptor,
    endpoints: () => ({}),
    tagTypes: [
        "Requests",
        "RequestDetails",
        "Bookings",
        "AppointmentDetails",
        "ProviderDetails",
        "Notifications",
        "SpHome",
        "SpBookingLists",
        "SpAppointmentDetails",
        "SpNotifications",
        "SpSlots",
        "UserProfile",
        "Kids",
        "UserFavorites",
    ],
});
